<template>
  <div class="container">
    <p class="heading-secondary-main">
      Для сотрудников ПКБ
    </p>
    <div class="card__list mb--4">
      <template v-if="isLoading">
        <ReportCardPlaceholder
          v-for="item in 8"
          :key="item"
        ></ReportCardPlaceholder>
      </template>
      <template v-else>
        <ReportCard
          v-for="report in employeeReport"
          :key="report.id"
          :report="report"
        ></ReportCard>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { actionTypes } from "@/store/modules/report";
import ReportCard from "@/components/common/report-card/ReportCard.vue";
import ReportCardPlaceholder from "@/components/common/report-card/ReportCardPlaceholder.vue";
import {EMPLOYEE_GROUP_ID} from "@/views/ForEmployees/config/config";
export default {
  components: { ReportCardPlaceholder, ReportCard },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      isLoading: state => state.report.isLoading,
      reports: state => state.report.data,
      error: state => state.report.error
    }),
    employeeReport() {
      return this.reports?.data.filter(report => report.group === EMPLOYEE_GROUP_ID);
    }
  },
  mounted() {
    this.getReportList();
  },
  methods: {
    getReportList() {
      this.$store.dispatch(actionTypes.getReportListAction);
    },
  }
};
</script>


<style lang="scss" scoped>
.card__list{
  display: grid;
  grid-template-columns: repeat(3,1fr);
  gap: 20px;
}
</style>
